import type { ReportContext } from './error-reporter';

/**
 * `reportError` sem pesar no chunk inicial (spec `crm-alvo-v2-fechamento`,
 * fatia 6): o reporter (`./error-reporter`) so e' baixado na primeira vez que
 * algo da errado — o caminho feliz do boot nao paga por ele.
 *
 * Usado pelo que precisa estar no boot e, mesmo assim, reportar erro: a
 * fronteira de erro (`ErrorBoundary`) e os ouvintes globais do `main.tsx`.
 * Codigo que ja vive num chunk lazy importa `reportError` direto.
 *
 * Se o proprio chunk do reporter nao carregar (rede caiu, deploy trocou o
 * hash), o erro original NAO some: vai para o console junto com o motivo.
 */
export function reportErrorDeferred(error: unknown, context?: ReportContext): Promise<void> {
  return import('./error-reporter')
    .then(({ reportError }) => reportError(error, context))
    .catch((loadError: unknown) => {
      console.error('[error-reporter] reporter indisponivel; erro original:', error, loadError);
    });
}
